(function () {

	'use strict';


	let cologicCustomKontakt = {



		formok: true,


    setKontakt: function () {

			let that = this;
			$('.valCheck').bind('input', function () {
				that.validateTextField($(this), $(this).val());
			}).bind('change', function () {
				that.validateTextField($(this), $(this).val());
			});

			$('.siteUrl').val(window.location);
		},


		// Validierung
		validateTextField: function (_elem, _val) {

			let that = this;
			if($(_elem).prop('required') || $(_elem).val() !== '' ) {

				switch ($(_elem).attr('id')) {
					case 'lastname' :
					case 'firstname' :
					case 'extra1' :
					case 'vorname' :
					case 'nachname' :
					case 'firma' :
						if (_val.length > 1) {
							if (that.validateText(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'anrede' :
					case 'betreff' :
						if (_val) {
							if (!$(_elem).hasClass('fgBlack')) {
								$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'nachricht' :
						if (_val.length > 2) {
							if (that.validateMessage(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'telefon' :
					case 'telefonPopup' :
						if (_val.length > 4) {
							if (that.validatePhone(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'email' :
						if (_val.length > 5) {
							if (that.validateEmail(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}

							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'fileInput1' :
						if (_val.length > 0) {
							if (_val.endsWith('.pdf') || _val.endsWith('.doc') || _val.endsWith('.docx') || _val.endsWith('.txt')) {
								if (!$(_elem).parent().find('span').hasClass('fgBlack')) {
									$(_elem).parent().find('span').addClass('fgBlack validatedBorder').removeClass("error");
								}

							} else {
								if ($(_elem).parent().find('span').hasClass('fgBlack')) {
									$(_elem).parent().find('span').removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).parent().find('span').hasClass('fgBlack')) {
								$(_elem).parent().find('span').removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

				}

			}

		},


		// Text validieren
		validateText: function ($text) {
			let textReg = /^[a-zA-ZäöüÄÖÜß0-9.,_\-&/+ ']{2,50}$/;
			return textReg.test( $text );
		},

		// Textarea validieren
		validateMessage: function ($text) {
			let messageReg = /^[a-zA-ZäöüÄÖÜß0-9.,;:!?()%$§€@_#*"´`\-&/+ '\r\n\t]{2,}$/;
			return messageReg.test( $text );
		},

		// Telefon validieren
		validatePhone: function ($phone) {
			let phoneReg = /^[0-9\-/+ ']{4,30}$/;
			return phoneReg.test( $phone );
		},

		// E-Mail validieren
		validateEmail: function ($email) {
			let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			return emailReg.test( $email );
		},


		// Error & Required Check

		finalFormCheck: function (formId, _elem) {
            console.log('in finalFormCheck');

			let that = this;

			that.formok=true;

			$('#'+formId+' .valCheck').each(function(){
				if($(this).prop('required')){
					that.validateTextField( $(this), $(this).val() );
				}
			});



			$('#'+formId+' .confirmation').each(function(){
				that.dataProtectConfirm( $(this) );
			});
			// console.log(that.formok);
            if (that.formok) {
                // if ($(_elem).data('isclicked') == 'false') {
                // if (!$(_elem).data('isclicked')) {
               if (!$(_elem).hasClass("justsend")) {
                    if(formId == 'kontaktform-nl-01'){
                        // that.sendForm(formId);
                        // $('#' + formId).trigger( "submit" );
                        $('#' + formId).submit();
                        // console.log('SUBMIT');
                        that.scrollToId(formId);
                        $('#' + formId + ' .contactResponse').removeClass('inactive');
                    }else{
                            that.sendForm(formId);
                    }

                    $(_elem).addClass("justsend");
                    setTimeout(function () {
                        $(_elem).removeClass("justsend");
                    }, 8000);
               }

            } else {

                $('.errorFeedBack').css('visibility', 'visible');
            }

		},

        scrollToY: function (_y) {
            $('html, body').animate({scrollTop: _y}, '200');
        },
        // scrollToId: function (_id) {
        //     let offSet = $('.iconContainer').innerHeight();
        //     // let offSet = $('#headerMain').innerHeight();
        //     this.scrollToY($('#' + _id).offset().top - (offSet + 50));
        // },

		checkFormFiled: function (_id) {

			if ( !$('#'+_id ).hasClass('fgBlack') ){
				$('#'+_id ).addClass('error')
				this.formok = false
			}

		},


		dataProtectConfirm: function (_elem) {

			if(!$(_elem).prop('checked')){
				$(_elem).addClass('error');
				this.formok = false;
			}else{
				$(_elem).removeClass('error');
			}
		},


		sendForm: function (_id) {
            let that = this;

           // var mailHandlerURL =  _baseUrl+"index.php?id=315";
            $('#'+_id+' .errorFeedBack').hide();

            var inVals;

            var form = document.forms.namedItem(_id);
            inVals = new FormData(form);



            this.queryMailHandler(false, inVals, function(response_Data) {
                // response_Data = queryMailHandler_retVal;
                if(response_Data) {
                    if(response_Data == '1') {
                        $('#' + _id + ' .contactResponse').removeClass('inactive');
                    }else if(response_Data == '2'){
                        $('#' + _id + ' .contactResponseWarning').removeClass('inactive');
                    }
                    // that.scrollToId(_id);
                }else{
                    $('#'+_id+' .contactResponseFailed').removeClass('inactive');
                    // that.scrollToId(_id);


                }

            });

		},

		closeResponse: function () {
			$('.contactResponse').addClass('inactive');
			$('.overlay-container').addClass('hide');
		},

		closeResponseFailed: function () {
			$('.contactResponseFailed').addClass('inactive');
			$('.overlay-container').addClass('hide');
		},

		closeResponseWarning: function () {
			$('.contactResponseWarning').addClass('inactive');
			$('.overlay-container').addClass('hide');
		},


        //------------------------------

        /*********** Ajax DB Abfragen Start ******************/



        queryMailHandler: function (handleAsJson, _params, ajaxCallback) {
            let _baseUrl = $('base').prop('href');

            let trgAdress = _baseUrl + "mailresponse";
            // let trgAdress = _baseUrl + "index.php?id=249";
            // let trgAdress = _baseUrl + "index.php?id=315";
            // console.log(handleAsJson);
            // console.log(_params);
            // console.log(trgAdress);
            $.ajax({
                type: 'post',
                cache: false,
                data: _params,
                url: trgAdress,
                processData: false,
                contentType: false

            })
                .done(function (data) {
                    try {
                        let response;
                        //remove BOM + parse json
                        if (handleAsJson) {
                            response = $.parseJSON(data.trim());
                        } else {
                            response = data.trim();
                        }

                        if (ajaxCallback)
                            ajaxCallback(response);
                        return (response);

                    } catch (err) {
                        alert("Fehler: " + err);
                    }
                })
                .fail(function (err) {
                    alert("Es ist ein Fehler aufgetreten: " + err);
                });
        },

        showFilename: function (e) {
            $(e).prev('span').html($(e)[0].files[0].name);
        },

        seturl: function(_elem){
            $(_elem).val(window.location);
        }

    }

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicCustomKontakt);
}());